import React from "react";
import "./Slogen.scss";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";


export function Slogen() {
    const lang = LOCALES_HELPER.getLan();


    return <>
        <section className="pt-medium pb-medium light-color">

            <div className="container">
                <div className="row">
                    <div className="col-md-12 text-center icon-blue" data-nekoanim="fadeInUp" data-nekodelay="200">
                        <div className="mb">
                            <i className="icon-glyph-10 large"></i>
                            <i className="icon-glyph-10 large"></i>
                            <i className="icon-glyph-10 large"></i>
                        </div>
                        <h1>
                            ENDO One Solution<br/><small>{DEFAULT_LOCALE === lang ? "瑞柏安，致力于一站式根管解决方案" : ""}</small>
                        </h1>
                    </div>
                </div>
            </div>

        </section>
    </>
}
